<template>
  <f7-page :page-content="false">
    <f7-navbar title="Códigos SWIFT" :back-link="$t('atras')"></f7-navbar>
    <f7-page-content class="full-height">
      <r-list
        ref="rlist"
        slot="default"
        :dbAdapter="SwiftCache"
        sort="codigoBanco"
        sortDir="ASC"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        filtersName="swiftcache"
      >
        <template v-slot:before="{rlist}">
          <f7-card-header>
            <div class="data-table-header">
              <div class="data-table-title">
                <f7-link href="/swiftcache/new/" icon-f7="plus" v-tooltip="'Nuevo'"></f7-link>
              </div>
              <div class="data-table-actions">
                <f7-link icon-f7="arrow_counterclockwise" @click="rlist.reload()" v-tooltip="'Recargar'"></f7-link>
                <f7-link icon-f7="doc_text" @click="rlist.exportExcel()" v-tooltip="'Exportar Excel'"></f7-link>
                <f7-link :class="{disabled: rPanelOpenedByBreakpoint}" icon-f7="line_horizontal_3_decrease" @click="$refs.rpanel.toggle()" v-tooltip="'Filtros'"></f7-link>
              </div>
            </div>
          </f7-card-header>
        </template>

        <template v-slot:header="{rlist}">
          <thead class="thead-sticky">
            <tr>
              <th class="checkbox-cell" style="width: 2rem;">
                <label class="checkbox">
                  <input type="checkbox" @change="rlist.toggleSelectAll($event.target.checked)" />
                  <i class="icon-checkbox"></i>
                </label>
              </th>
              <th style="min-width:1em;" @click="rlist.setOrder('codigoBanco')" :class="rlist.sortableClasses('codigoBanco')">Código Banco</th>
              <th style="min-width:1em;" @click="rlist.setOrder('swift')" :class="rlist.sortableClasses('swift')">SWIFT</th>
              <th style="min-width:1em;" @click="rlist.setOrder('nombreBanco')" :class="rlist.sortableClasses('nombreBanco')">Nombre Banco</th>
            </tr>
          </thead>
        </template>

        <template v-slot:default="{vlData,rlist}">
          <tr v-for="(item) in vlData.items" :key="'swift-'+item.id">
            <th class="checkbox-cell">
              <label class="checkbox">
                <input type="checkbox" :checked="item.id in rlist.selected" @change="rlist.toggleSelect(item, $event.target.checked)" />
                <i class="icon-checkbox"></i>
              </label>
            </th>
            <td>{{item.codigoBanco}}</td>
            <td>{{item.swift}}</td>
            <td>{{item.nombreBanco}}</td>
            <td class="text-align-right right-column-sticky">
              <f7-link icon-f7="eye" color="green" :href="`/swiftcache/view/${item.id}/`"></f7-link>
              <f7-link icon-f7="square_pencil" color="blue" :href="`/swiftcache/edit/${item.id}/`"></f7-link>
              <f7-link icon-f7="trash" color="red" @click="rlist.deleteItem(item.id)"></f7-link>
            </td>
          </tr>
        </template>

        <template v-slot:afterInner="{rlist}">
          <rPanel ref="rpanel" side="right" @openedByBreakpoint="rPanelOpenedByBreakpoint=true" @closedByBreakpoint="rPanelOpenedByBreakpoint=false" v-slot="{rpanel}">
            <r-form @submit="rlist.setFilter($event); rpanel.close();" filtersName="swiftcache">
              <template v-slot:before="{rform}">
                <f7-toolbar>
                  <div>Filtro</div>
                  <f7-link icon-f7="bin_xmark" @click="rform.clear();"></f7-link>
                </f7-toolbar>
              </template>
              <template v-slot="{rform}">
                <f7-list no-hairlines-md>
                  <template v-slot:list>
                    <r-input maxlength="256" floating-label label="Código Banco" :form="rform" type="text" name="codigoBanco"></r-input>
                    <r-input maxlength="256" floating-label label="SWIFT" :form="rform" type="text" name="swift"></r-input>
                    <r-input maxlength="256" floating-label label="Nombre Banco" :form="rform" type="text" name="nombreBanco"></r-input>
                    <f7-button type="submit" class="margin-vertical" icon-f7="search">Buscar</f7-button>
                  </template>
                </f7-list>
              </template>
            </r-form>
          </rPanel>
        </template>

        <template v-slot:after="{rlist}">
          <f7-card-footer>
            <span><b>{{$tc('rlist.n_registros', rlist.count, {count:rlist.count})}}</b></span>
          </f7-card-footer>
        </template>
      </r-list>
    </f7-page-content>
  </f7-page>
</template>

<script>
import rList from "./../../components/rList.vue";
import rPanel from "./../../components/rPanel.vue";
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import SwiftCache from "./../../js/db/SwiftCache.js";

export default {
  components: { rList, rPanel, rForm, rInput },
  data() {
    return {
      SwiftCache,
      rPanelOpenedByBreakpoint: false
    };
  }
};
</script>
